import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { PatientModel } from '../../core/api/models';
import { ParentApiService } from '../../core/api/services';
import { AppVersionService } from '../../core/services/app-version.service';
import { FrontendDiagnosticsService } from '../../core/services/frontend-diagnostics.service';
import { Utils } from '../../core/utils';
import { AlertService } from '../../shared/services/alert.service';
import { ParentAuthService } from '../parent-auth.service';
import { ParentSessionService } from '../collect/parent-session.service';

@Component({
  selector: 'app-parent-menu',
  templateUrl: './parent-menu.component.html',

  standalone: false,
})
export class ParentMenuComponent {
  @Input() title = '';
  @Input() patients: PatientModel[] = [];
  @Input() selectedPatientID: number | null | undefined;
  @Output() patientChanged = new EventEmitter<PatientModel>();
  get patientOptions() { return this.patients.map(patient => ({ ID: patient.ID, FullName: patient.PatientName ?? '', searchString: patient.PatientName ?? '' })); }
  openMenu = false;
  sendingLogs = false;
  signingOut = false;

  constructor(public parentAuth: ParentAuthService, private parentSessions: ParentSessionService,
    private parentApi: ParentApiService, private diagnostics: FrontendDiagnosticsService,
    private appVersion: AppVersionService, private alerts: AlertService, private router: Router) { }

  openOfflinePatients(): void { this.router.navigate(['/parent/offline']); }

  changePatient(patientID: number): void {
    const patient = this.patients.find(x => x.ID === patientID);
    if (patient) { this.openMenu = false; this.patientChanged.emit(patient); }
  }

  sendLogs(): void {
    this.alerts.confirm('Send logs', 'Send diagnostic information and any unsynced parent session data to support?')
      .subscribe(confirmed => {
        if (!confirmed || this.sendingLogs) return;
        this.sendingLogs = true;
        this.parentApi.SendLogs({ body: {
          AppVersion: this.appVersion.getVersionRaw() ?? undefined,
          Context: 'Parent menu: Send logs',
          FrontendErrors: this.diagnostics.getRecentEntries(),
          OfflineUnsyncedDataJson: this.parentSessions.getUnsyncedDataJson(),
        }}).subscribe({
          next: () => { this.sendingLogs = false; this.openMenu = false; this.alerts.success('Logs sent successfully'); },
          error: error => { this.sendingLogs = false; this.alerts.error(Utils.getErrorMessageFromErrorResponse(error)); }
        });
      });
  }

  signOut(): void {
    this.signingOut = true;
    this.parentSessions.syncPendingSessions().subscribe(() => {
      this.parentSessions.leaveSession();
      this.parentAuth.signOut();
      this.router.navigate(['/parent/signin']);
    });
  }
}
